import { render } from "./templateManage.vue?vue&type=template&id=3d15d3df&scoped=true&ts=true"
import script from "./templateManage.vue?vue&type=script&lang=ts"
export * from "./templateManage.vue?vue&type=script&lang=ts"

import "./templateManage.vue?vue&type=style&index=0&id=3d15d3df&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d15d3df"]])

export default __exports__